const DEFAULT_LANG = "jp";

export function resolveLang() {
  const savedLang = localStorage.getItem("lang");
  const langManual = localStorage.getItem("lang_manual") === "1";

  if (langManual && (savedLang === "jp" || savedLang === "ch")) {
    return savedLang;
  }

  localStorage.setItem("lang", DEFAULT_LANG);
  localStorage.removeItem("lang_manual");
  return DEFAULT_LANG;
}

export function setManualLang(lang) {
  localStorage.setItem("lang", lang);
  localStorage.setItem("lang_manual", "1");
}
